import axios from "axios";
// 获取兑换码
export async function getExchangeCode(){
  return axios.get(process.env.NEXT_PUBLIC_INTERFACE_PREFIX + `/campaign/hunt/code/get?webName=dingtone&source=`+encodeURIComponent(document.referrer))
}